<template>
  <div class="row full-width justify-center">
    <div :class="['col-11 q-py-md', isMobile ? undefined : 'q-px-sm']">
      <div class="column full-width q-gutter-y-md">

        <!-- title -->
        <div class="row full-width">
          <div class="text-h6 text-black">
            آخرین فعالیت‌ها
          </div>
        </div>

        <!-- filters -->
        <div v-if="filterChips && filterChips.length > 0" class="row full-width">
          <div class="row q-gutter-sm items-center">
            <div v-for="filter of filterChips" class="col-auto">
              <div class="row full-width border-radius bg-secondary q-px-sm q-py-xs items-center text-white">

                <!-- label -->
                <div class="q-mr-sm text-subtitle2 text-weight-regular">
                  #{{ filter && filter.title && filter.title.trim().replaceAll(' ', '_') }}
                </div>

                <!-- remove -->
                <q-btn class="border-radius" size="sm" color="white" icon="la la-times" flat dense
                       @click="removeFilter(filter)"/>

              </div>
            </div>
          </div>
        </div>

        <!-- reports -->
        <div class="full-width">
          <div class="row q-pl-none q-col-gutter-md">
            <div v-for="report of reports && reports" class="col-12 col-md-3">
              <report-item :report="report" @setFilter="addFilter($event)"/>
            </div>
          </div>
        </div>

        <!-- pagination -->
        <div v-if="pagination.totalPages > 1" class="row full-width justify-center items-center">
          <q-pagination :model-value="pagination.page"
                        class="row q-gutter-x-xs"
                        :max="pagination.totalPages"
                        :max-pages="isMobile? 4 : 8"
                        color="grey-8"
                        text-color="white"
                        size="0.8rem"
                        icon-first="la la-angle-double-left"
                        icon-last="la la-angle-double-right"
                        icon-prev="la la-angle-left"
                        icon-next="la la-angle-right"
                        direction-links
                        boundary-links
                        boundary-numbers
                        push
                        dense
                        @update:model-value="changePage"
          />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {useMeta} from "quasar";
import ReportItem from "../components/ReportItem";

export default {
  name: "Reports",
  components: {ReportItem},
  async preFetch({store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath}) {
    await store.dispatch('loadReports', {page: 1, take: 8})
    if (ssrContext) {
      await store.dispatch('getMeta', {pageUrl: ssrContext.req.headers.host + currentRoute.path})
    } else {
      await store.dispatch('getMeta', {pageUrl: window.location.host + currentRoute.path})
    }
    let meta = {}
    meta.title = store.state.preFetch?.pageMeta?.metaTitle
    meta.description = store.state.preFetch?.pageMeta?.metaDescription
    meta.keywords = store.state.preFetch?.pageMeta?.metaKeywords
    meta.script = null
    return await store.dispatch('setMeta', meta)
  },
  data: () => ({
    filters: [],
    filterChips: [],
    page: 1,
    totalPages: 1,
  }),
  computed: {
    isMobile() {
      return this.$q.screen.lt.md
    },
    reportList() {
      return this.$store.state.preFetch.reports
    },
    reports() {
      return this.$store.state.preFetch.reports
    },
    pagination() {
      return {
        page: this.page,
        totalPages: Math.round(this.$store.state.preFetch.reports[0]?.totalCount / (this.isMobile ? 4 : 8))
      }
    }
  },
  methods: {
    async loadReports() {
      let filters = JSON.stringify(this.filters)
      await this.$store.dispatch('loadReports', {
        page: this.pagination.page,
        take: 8,
      })
    },
    async addFilter(filter) {
      if (this.filters.findIndex(x => x[0] == filter.fieldName) < 0) {
        this.filters.push([filter.fieldName, '=', [filter.value], filter.title])
        this.filterChips.push({
          id: filter.value,
          title: filter.title
        })
        document.querySelector('body').scrollIntoView()
        this.pagination.page = 1
        await this.setUrl()
        await this.loadReports()
        this.pagination.totalPages = this.reportList && this.reportList.totalPages
      }
    },
    async removeFilter(filter) {
      let index = this.filters.findIndex(x => x[2][0] === filter.id)
      this.filters.splice(index, 1)
      this.filterChips.splice(index, 1)
      document.querySelector('body').scrollIntoView()
      this.pagination.page = 1
      await this.setUrl()
      await this.loadReports()
    },
    async changePage(evt) {
      document.querySelector('body').scrollIntoView()
      this.pagination.page = evt
      this.page = evt
      await this.loadReports()
      if (evt === 1)
        await this.$router.replace(`/reports`)
      else
        await this.$router.replace(`/reports/page/${this.page}`)
    },
    // async setUrl() {
    //   let index = null
    //   let charityId = null
    //   let charityTitle = ''
    //   let projectId = null
    //   let projectTitle = ''
    //   index = this.filters.findIndex(x => x[0] === 'tenantId')
    //   if (index >= 0) {
    //     charityId = this.filters[index][2][0]
    //     charityTitle = this.filters[index][3].replaceAll(' ', '-')
    //   }
    //   index = this.filters.findIndex(x => x[0] === 'projectId')
    //   if (index >= 0) {
    //     projectId = this.filters[index][2][0]
    //     projectTitle = this.filters[index][3].replaceAll(' ', '-')
    //   }
    //   let filters = `${charityId ? `charity,in,${charityId},${charityTitle}` : ''}${charityId && projectId ? '_' : ''}${projectId ? `project,in,${projectId},${projectTitle}` : ''}`
    //   await this.$router.push({
    //     path: this.$route.fullPath,
    //     query: {
    //       page: this.pagination.page
    //     }
    //   })
    // },
    // async setFilterFromUrl() {
    //   this.pagination.page = 1
    //   if (this.$route.query.page) this.pagination.page = this.$route.query.page
    //   let urlFilters = []
    //   if (this.$route.query.filters) urlFilters = this.$route.query.filters.split('_')
    //   if (urlFilters.length > 0)
    //     urlFilters.forEach(x => {
    //       let filter = x.split(',')
    //       if (filter[0] === 'charity') {
    //         this.filters.push(['tenantId', '=', [parseInt(filter[2])], filter[3]])
    //         this.filterChips.push({
    //           id: filter[2],
    //           title: filter[3].replaceAll('-', '_')
    //         })
    //       } else if (filter[0] === 'project') {
    //         this.filters.push(['projectId', '=', [parseInt(filter[2])], filter[3]])
    //         this.filterChips.push({
    //           id: filter[2],
    //           title: filter[3].replaceAll('-', '_')
    //         })
    //       }
    //     })
    //   await this.setUrl()
    //   await this.loadReports()
    // }
  },
  async mounted() {
    useMeta(this.$store.state.meta)
  }
}
</script>
